import { useState, useEffect } from 'react';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    '/images/hero00.webp',
    '/images/hero02.webp',
    '/images/hero03.webp'
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section className="relative h-[700px] overflow-hidden bg-gray-900">
      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="w-full h-full">
            <img 
              src={slide} 
              alt={`Hero ${index + 1}`}
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-br from-black/60 via-black/40 to-black/60"></div>
        </div>
      ))}

      {/* Content Overlay */}
      <div className="absolute inset-0 flex items-center">
        <div className="max-w-7xl mx-auto px-4 w-full">
          <div className="max-w-3xl">
            <div className="inline-block mb-6">
              <span className="text-teal-400 font-semibold text-sm uppercase tracking-wider bg-white/10 backdrop-blur-sm px-5 py-2 rounded-full border border-white/20">
                Since 2012
              </span>
            </div>
            <h1 className="text-5xl md:text-7xl font-bold mb-8 leading-tight text-white">
              Empowering Lives with Purpose & Dignity
            </h1>
            <p className="text-xl md:text-2xl mb-10 text-white/95 leading-relaxed">
              Comprehensive support services for individuals with intellectual and developmental disabilities in Los Angeles County
            </p>
            <div className="flex flex-wrap gap-4">
              <a 
                href="#contact" 
                className="bg-teal-600 text-white px-8 py-4 rounded-lg hover:bg-teal-700 transition-all font-semibold text-lg whitespace-nowrap cursor-pointer shadow-xl hover:shadow-2xl hover:scale-105"
              >
                Get Started Today
              </a>
              <a 
                href="#about" 
                className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg hover:bg-white/20 transition-all font-semibold text-lg whitespace-nowrap cursor-pointer shadow-xl border border-white/30"
              >
                Learn More
              </a>
            </div>
            
            {/* Quick Stats */}
            <div className="grid grid-cols-3 gap-6 mt-12 max-w-2xl">
              <div className="text-white">
                <div className="text-4xl font-bold mb-1 text-teal-400">13+</div>
                <div className="text-sm text-white/80">Years Experience</div>
              </div>
              <div className="text-white border-l border-r border-white/20 px-6">
                <div className="text-4xl font-bold mb-1 text-teal-400">3</div>
                <div className="text-sm text-white/80">Regional Centers</div>
              </div>
              <div className="text-white">
                <div className="text-4xl font-bold mb-1 text-teal-400">100%</div>
                <div className="text-sm text-white/80">Commitment</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-6 top-1/2 -translate-y-1/2 w-14 h-14 flex items-center justify-center bg-white/15 hover:bg-white/25 backdrop-blur-sm rounded-full transition-all cursor-pointer border border-white/20"
        aria-label="Previous slide"
      >
        <i className="ri-arrow-left-s-line text-white text-3xl"></i>
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-6 top-1/2 -translate-y-1/2 w-14 h-14 flex items-center justify-center bg-white/15 hover:bg-white/25 backdrop-blur-sm rounded-full transition-all cursor-pointer border border-white/20"
        aria-label="Next slide"
      >
        <i className="ri-arrow-right-s-line text-white text-3xl"></i>
      </button>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`h-1 rounded-full transition-all cursor-pointer ${
              index === currentSlide ? 'bg-white w-10' : 'bg-white/40 w-6'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
